import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import AdminTienda from "./pages/AdminTienda";
import MantenimientoGate from "./container/Mantenimiento/MantenimientoGate";


const AnimatedRoutes = () => {
  const location = useLocation();

  return (
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <MantenimientoGate>
              <Home />
            </MantenimientoGate>
          }
        />
        <Route path="/admin-tienda" element={<AdminTienda />} />
      </Routes>
  );
};

const App = () => (
  <Router>
    <AnimatedRoutes />
  </Router>
);

export default App;
